import { useState, useEffect } from 'react';
import Sidebar from '../components/nav/Sidebar';
import Footer from '../components/sections/Footer';
import { useChatContext } from '../contexts/ChatContext';
import { capitalizeFirstLetter } from '../utils/format';
import Select from '../components/selects/Select';
import { useLoaderContext } from '../contexts/LoaderContext';
import { useAuthContext } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';

export default function MainLayout({ children }: React.PropsWithChildren<{}>) {
	let navigate = useNavigate();
	let location = useLocation();
	const {logout} = useAuthContext();
	const {sidebarOpen, setSidebarOpen} = useAppContext();
	const {listVectorIndexes, vectorstores, deleteVectorstore} = useLoaderContext();
    const {type, setType, chatPayload, setChatPayload} = useChatContext();
	const [loading, setLoading] = useState(false);
	const [icon, setIcon] = useState('bi bi-robot');

	useEffect(() => {
		if (type === 'default') {
			setIcon('bi bi-chat-right-dots-fill');
		}
		if (type === 'agent' || location.pathname === '/agents') {
			setIcon('bi bi-robot');
		}
		if (type === 'vectorstore') {
			setIcon('bi bi-folder-fill');
		}
	}, [type]);

    return (
        <div className={`page-wrapper${sidebarOpen ? ' toggled' : ''}`}>
			<div className="page-header">

				<div className="brand">
					<a onClick={()=>navigate('/agents')} className="logo">
						<img src="https://pxtportal.com/img/logo.png" className="d-none d-md-block me-4" alt="BlueDox Admin Dashboard" />
						<img src="https://pxtportal.com/img/logo.png" className="d-block d-md-none me-4" alt="BlueDox Admin Dashboard" />
					</a>
				</div>

				<div className="toggle-sidebar" id="toggle-sidebar" onClick={()=>setSidebarOpen(!sidebarOpen)}>
					<i className="bi bi-list"></i>
				</div>

				<div className="header-actions-container">
					{/* <div className="search-container me-3 d-xl-block d-lg-none">
						<div className="input-group">
							<input type="text" className="form-control" placeholder="Search Jobs" />
							<button className="btn btn-outline-secondary" type="button">
								<i className="bi bi-search"></i>
							</button>
						</div>
					</div> */}

					{/* <div className="header-actions d-xl-flex d-lg-none">
						<a href="events.html" data-bs-toggle="tooltip" data-bs-placement="bottom"
							data-bs-custom-class="custom-tooltip-red" data-bs-title="Events List">
							<i className="bi bi-bell font-1xx"></i>
						</a>
						<a href="account-settings.html" data-bs-toggle="tooltip" data-bs-placement="bottom"
							data-bs-custom-class="custom-tooltip-blue" data-bs-title="Settings">
							<i className="bi bi-gear font-1xx"></i>
						</a>
					</div> */}

					<div className="header-profile d-flex align-items-center justify-content-end position-relative ms-3">
						<div className="dropdown">
							<a href="#" onClick={(e)=>e.preventDefault()} id="userSettings" className="user-settings" data-toggle="dropdown" aria-haspopup="true">
								<span className="user-name d-none d-md-block">Ryan Eggleston</span>
								<span className="avatar">
									<img src="https://avatars.githubusercontent.com/u/40816745?v=4" alt="User Avatar" />
									<span className="status online"></span>
								</span>
							</a>
							<div className="dropdown-menu dropdown-menu-end" aria-labelledby="userSettings">
								<div className="header-profile-actions">
									<a onClick={()=>navigate('/')}>Chat</a>
									<a onClick={()=>navigate('/agents')}>Agents</a>
									<a href="/">Settings</a>
									<a href="https://precision-x.gitbook.io/api-documentation">Documentation</a>
									<a onClick={logout}>Logout</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container">
				<Sidebar />
				<div className="content-wrapper-scroll">
					<div className="main-header d-flex align-items-center justify-content-between position-relative">
						<div className="d-flex align-items-center justify-content-center">
							<div className="page-icon pe-1">
								<i className={icon}></i>
							</div>
							<div className="page-title d-none d-md-block">
								<h5>Welcome back, Ryan</h5>
							</div>
						</div>
						{type === 'agent' && (
							<h4>Tools enabled: {chatPayload.tools.length}</h4>
						)}
						{type === 'vectorstore' && (
							<Select
								cleared
								handleChange={(item: any) => {
									if (item) {
										setChatPayload({ ...chatPayload, retrieval: {...chatPayload.retrieval, index_name: item.value} });
										sessionStorage.setItem('vectorstore', item.value);
									} else {
										setChatPayload({ ...chatPayload, retrieval: {...chatPayload.retrieval, index_name: ''} });
										sessionStorage.removeItem('vectorstore');
									}
								}}
								loading={loading}
								value={
									chatPayload.retrieval?.index_name
									? {label: chatPayload.retrieval?.index_name, value: chatPayload.retrieval?.index_name}
									: null
								}
								deleteCallback={async (item: {label: string, value: string}) => {
									try {
										await deleteVectorstore({
											provider: chatPayload.retrieval.provider,
											vectorstore: item.value
										})
										alert(`Vectorstore ${item.label} deleted successfully.`)
									} catch (error: unknown) {
										// Handle error here
										console.error(error);
										alert((error as any).response.data.detail);
									}
								}}
								options={vectorstores}
								onMenuOpen={async () => {
									if (vectorstores.length < 1) {
										setLoading(true);
									}
									await listVectorIndexes(chatPayload.retrieval.provider);
									setLoading(false);
								}}
							/>
						)}
						<div className="btn-group">
							{location.pathname !== '/agents' && (
								<>
									<button type="button" className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
										{type ? capitalizeFirstLetter(type) : 'Select Type'}
									</button>
									<ul className="dropdown-menu">
										<li className="dropdown-item" onClick={()=>setType('default')}>
											Chat
										</li>
										<li className="dropdown-item" onClick={()=>setType('vectorstore')}>
											Vectorstore
										</li>
										<li className="dropdown-item" onClick={()=>setType('agent')}>
											Agent
										</li>
									</ul>
								</>
							)}
						</div>
					</div>
				</div>


				<div className="content-wrapper">
					{children}
				</div>
			</div>
			<Footer />
		</div>
    );
}